import { PRODUCT, SECONDARY_PRODUCT } from "@/constants";

const brandImpact = {
  avanti: true,
  staysure: false,
  expat: false,
};

const brand: "staysure" | "avanti" | "expat" =
  SECONDARY_PRODUCT === "expat"
    ? "expat"
    : (PRODUCT as "staysure" | "avanti") ?? "staysure";

const isCruiseImpact = brandImpact[brand];

export default isCruiseImpact;
